<style lang="less">
	  @import './search_input.less';
</style>
<template>
    <div class="search_div" >
        <div class="search_input">
            <input v-bind:style="{width: record.width + 'px' }" ref="sea" type="text" v-model="name" name="" :placeholder="record.placeholder" v-on:keyup.enter="submit"   @focus="doThis()" @blur="loseThis()" >
            <div title="搜索" >
                <img  @click="submit()"  src="./sousuo.png" >
            </div>
            <div title="历史记录" @click="personal_record()">
                <img v-show="navigation"  src="./dh1.png" >
                <img v-show="!navigation"  src="./dh2.png" >
            </div>
            
        </div>
        <div @mouseenter="enter()" @mouseleave="leave()"   class="search_down" v-show="record.flog" v-bind:style="{height: record.height + 'px' ,width: record.width + 'px' }">
            <div class="search_downhead">
                <div class="search_down_list"   @mouseenter="enter_search()" @mouseleave="leave_search()" >
                    <div class="search_list_1"  v-for="item in list" @click="conditions_search(item)"   >
                        <img src="./ss1.png" >
                        <p>{{item.name}}</p>
                    </div>
                </div>
                <div class="search_down_ranking"  v-if="listsan.length > 0"  @mouseenter="enter_search()" @mouseleave="leave_search()" >
                    <div class="search_down_ranking_1" v-for="item in listsan"  @click="conditions_search(item)" >
                        <img  src="./rd.png">
                        <p>{{item.name}}</p>
                    </div>
                </div>
                <div class="search_down_record"   v-if="listgr.length > 0"  >
                    <div class="search_down_record_1" v-for="item in listgr">
                        <div  title="记录名称"   class="search_down_record_1a"  @mouseenter="enter_search()" @mouseleave="leave_search()"   @click="conditions_history(item)">
                            <div class="search_down_record_1left">
                                <!-- <img v-if="item.flog == '次数'" src="./ss2.png">
                                <img  v-else-if ="item.flog == '时间'" src="./sj.png"> -->
                                <div v-if="item.flog == '次数'" class="search_down_record_1leftcs" ></div>
                                <div v-else-if ="item.flog == '时间'" class="search_down_record_1leftsj" ></div>
                                <p >{{item.name}}</p>
                            </div>
                            <div class="search_down_record_1right">
                                <span >{{item.number }}<span v-if="item.flog == '次数'">次</span></span>
                            </div>
                        </div>
                        <div class="search_down_record_1b"  @click="conditions_delete(item)">
                            <div  title="删除记录"></div>
                        </div>
                    </div> 
                </div>
            </div>
            <div  class="search_down_end" v-if="record.personal">
                <div @click="personal_time()">
                    <p>时间</p>
                </div>
                <hr>
                <div  @click="personal_number()">
                    <p>次数</p>
                </div>
                <hr>
                <div  @click="personal_history()">
                   <p>删除历史</p> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '../../app/event'
export default {
    components: {
    },
    props: {
        list_old: {
            type: Array
        },
        listsan: {
            type: Array
        },
        listgr: {
            type: Array
        },
        record:{
            type: Object
        },
    },
    data() {
        return {
            name:"",
            /*record:{
                flog:true,
                height:410,
                placeholder:"",
                personal:true
            },*/
            list:[
            ],
            shut_down:false,//判断是否关闭 进入弹出框的
            shut_down_search:false, 
            shut_down_search_falg:false,
            navigation:true,//判断是否精确导航
            navigation_flog:false,//判断是否点击了列表
            /*list_old:[
                {name:"南京基础地图20181"},
            ],*/
        };
    },
    watch: {
        name: function (val, oldVal) {
           this.list_matching(val)
        },
    },
    mounted() {            
    },
    methods: {
        submit:function() {
            this.$emit('conditions_search',this.name)
        },
        doThis:function(){
            this.shut_down == false
            this.list = this.list_old;
            this.navigation_flog  = false;
            if (this.navigation == true) {
                this.record.flog = true;
            }

        },
        loseThis:function(){
            if (this.shut_down_search == true) {
                this.shut_down_search_falg = true;
            } else{
                this.shut_down_search_falg = false;
            }
            if (this.shut_down == true) {
                return
            }
            if (this.navigation == false) {
                return
            }
            this.record.flog = false;
        },
        list_matching:function(item){
            if (this.navigation_flog == true) {
                return
            }
            this.list = [];
            var  arr = this.list_old;
            var patt1 = new RegExp(item);
            for (var i = 0; i < arr.length; i++) {
                var result = patt1.test(arr[i].name);
                if (result) {
                   this.list.push(arr[i])
                }
            }
        },
        personal_record:function(){
            this.navigation = !this.navigation;
            if(this.navigation == true){
                this.record.flog = false;
            }else{
                this.record.flog = true;
                this.list = this.list_old;
            }
        },
        enter:function(){
            this.shut_down  = true;
        },
        leave:function(){
            this.shut_down  = false;
            if (this.shut_down_search_falg == false) {
                if (this.navigation == true) {
                    this.$refs.sea.focus();
                }
            }
        },
        enter_search:function(){
            this.shut_down_search = true;
            this.$refs.sea.focus();
        },
        leave_search:function(){
            this.shut_down_search = false;
        },
        personal_time:function(){
            this.$emit('search_modify',"时间")
        },
        personal_number:function(){
            this.$emit('search_modify',"次数")

        },
        personal_history:function(){
            this.$emit('search_modify',"删除历史")

        },
        conditions_search:function(item){
            
            if (this.navigation == true) {
                this.record.flog = false;
            }else{
                this.navigation_flog = true;
            }
            this.name = item.name;
            this.$emit('conditions_search',item.name)
        },
        conditions_history:function(item){
            this.name = item.name;
            if (this.navigation == true) {
                this.record.flog = false;
            }
            
            this.$emit('conditions_history',item.name)
        },
        conditions_delete:function(item){
            this.$emit('conditions_delete',item.id)
        },
    },
    destroyed: function() {
        this.$off('search_modify');
        this.$off('conditions_search');
        this.$off('conditions_history');
        this.$off('conditions_delete');
    }
};
</script>

 


// WEBPACK FOOTER //
// search_input.vue?73bfd634